import notifier from "../notifier";
import 'timepicker/jquery.timepicker.min';
import 'timepicker/jquery.timepicker.min.css';
import {reInitScripts} from "../../utils/re-init-scripts";
import 'magnific-popup/dist/jquery.magnific-popup.min';

function setTabIndex ($container = $(document)) {
    let $inputs = $container.find('input, select').filter(':visible');
    let $readonly = $inputs.filter('[readonly]');

    $inputs.each((i, el) => {
        el.tabIndex = 0;
    });

    $readonly.attr('tabindex', '-1');
}

function init(element) {
    let warehouseList = [];
    let receiptList = [];
    let $cityIdFirst = null;
    const isAuthorized = window.isAuthorised.toLowerCase();
    const translates = window.translates.receipt;
    const $wrap = $('[data-delivery-wrapper]');
    const $body = $('body');
    const $receiptNumber = $(element).find('[name="receiptNumber"]');
    const $timeFromOrderDel = $wrap.find('[name="timeFromOrder"]');
    const $timeToOrderDel = $wrap.find('[name="timeToOrder"]');
    const $dateOrder = $wrap.find('[name="dateOrder"]');
    const $cityId = $(element).find('[name="cityId"]');
    const $needAuto = $(element).find('[name="needAuto"]');
    const $hydrobortDelivery = $(element).find('[name="hydrobortDelivery"]');;
    const $wrapper = $('[data-receipt-wrapper]');
    const $totalSum = $('[data-total-sum]');
    const $organizationNameOrder = $(element).find('[name="organizationNameOrder"]');
    const $emailOrder = $(element).find('[name="emailOrder"]');
    const $contactPersonOrder = $(element).find('[name="contactPersonOrder"]');
    const $contactPhoneOrder = $(element).find('[name="contactPhoneOrder"]');
    const $paymentType = $(element).find('[name="paymentType"]');
    let addedReceipts = [];

    let fromArr, toArr;

    let deliverySum = {
        'tarifCost': {
            "weight": 0,
            "volume": 0,
            "places": 0,
            "palletId": null,
            "cityId": null,
            "cost": null,
            "tarifName": null,
            "needAuto": false,
            "isPick": false,
            "hydroB": false,
            "isNegabarit": false,
            "numReceipts": null,
        }
    };

    let orderData = {
        "ReceiptOrder": null,
        "WarehouseIdOrder": null,
        "CityId": null,
        "AddressOrder": null,
        "DateOrder": null,
        "TimeFromOrder": null,
        "TimeToOrder": null,
        "OrganizationNameOrder": null,
        "PayTypeOrder": 0,
        "EmailOrder": null,
        "ContactPersonOrder": null,
        "ContactPhoneOrder": null,
        "IsHalfDiscont": 0,
        "HydroOrderCheck": false,
        "NeedAdditionalAutoCheck": false,
        "CommentOrder": null,
        "NoCallBack": false,
    };

    $(document).on('change', 'input, select, textarea', function () {
        setTabIndex();
    });

    $(document).on('click', '[data-search-receipt-btn]', function () {
        let receiptNumberValue = $('.is-active-place [name="receiptNumber"]').val();
        if (receiptNumberValue === '') {
            notifier.error(translates['fantasticEnterCity1'] ).then((noty) => {
                noty.show();
            });
        } else {
            if (addedReceipts.includes(receiptNumberValue)) {
                notifier.error(translates['youHaveAlreadyAddedThisReceipt']).then((noty) => {
                    noty.show();
                });
                return false;
            }
            getRequestDelivery(receiptNumberValue);
        }
    });

    $(document).on('click', '[data-remove-receipt]', function () {
        const $item = $(this).parents('[data-receipt-item]');
        addedReceipts = addedReceipts.filter((item) => {
            return item !== $item.data('receipt-number');
        });
        $item.remove();
        $('[data-receipt-wrapper]').children().each((index, item) => {
            $(item).find('[data-receipt-counter]').text($('[data-receipt-wrapper]').children().length - index);
        });

        if($('[data-receipt-wrapper]').children().length === 1) {
            const $currentPlace = $('.is-active-place');
            $currentPlace.find('[data-search-field]').addClass('_hide');
            $currentPlace.find('[data-select-available-receipts]').removeClass('_hide');
            $currentPlace.find('[data-search-select]').addClass('_hide');
            receiptsForDelivery();
        }
    });

    $(document).on('click', '[data-delivery-tarif]', function () {
        if($wrapper.find('[data-receipt-item]').hasClass('is-valid')) {
            deliveryCost();
        } else {
            notifier.error(translates['deliveryCostMessage']).then((noty) => {
                noty.show();
            });
        }
    });

    $(document).on('click', '[data-delivery-create]', function () {
        createDelivery();
    });

    $(document).on('select2:select', '[data-search-select] select', function () {
        getRequestDelivery(this.value);
    })

    $(document).on('select2:select', '[data-select-available-receipts] select', function () {
        getRequestDelivery(this.value);
    })

    $(document).on('click', '[data-add-receipt]', function () {
        if ($(this).hasClass('is-active')) {
            const $currentTemplate = $(this).parents('[data-receipt-item]');
            const data = setReceiptData($currentTemplate);
            const $currentTemplateCollapsed = $currentTemplate.find('[data-receipt-collapsed]');
            const template = $('#receiptItem').html();
            let $template = $(template);
            $wrapper.find('[data-receipt-item]').first().addClass('is-active-place');
            $currentTemplateCollapsed.find('[data-receipt-counter]').text($wrapper.children().length);
            $wrapper.prepend($template);
            $template.find('[data-receipt-form] [data-receipt-counter]').text($wrapper.children().length);
            $template.attr('id', 'receipts-' + parseInt($wrapper.children().length));
            updateReceiptInfo($currentTemplate, data);
            $template.addClass('is-active-place');
            toggleSearchField();
            $template.find('[data-search-select] select').html(receiptList.map((item) => {
                return `<option value="${item['Text']}">${item['Text']}</option>`
            })).val(null);
            reInitScripts($template[0]);
        }
    })

    function getTimeIntervals(date = null, timeProp = null) {
        //$body.addClass('is-loading');
        let url = 'https://delivery-auto.com:8202/api/ReceiptsOpen/GetTimeForOrder';
        let value = $dateOrder.val().split('.');
        value = value[2] + '-' + value[1] + '-' + value[0] + 'T00:00:00';

        $.ajax({
            url: url,
            type: 'get',
            data: {
                orderDate: date ?? value,
                isPick: false,
                timeFrom: timeProp
            },
            success: (response) => {
                let fromMin = response.data.timeFrom.min.substr(11, 5);
                let fromMax = response.data.timeFrom.max.substr(11, 5);
                let toMin = response.data.timeTo.min.substr(11, 5);
                let toMax = response.data.timeTo.max.substr(11, 5);
                let value = $timeFromOrderDel.find('option:selected').val();
                let timeFrom = [];
                let timeTo = [];
                if (response.data.orderDate) {
                    let date = new Date(response.data.orderDate);
                    $dateOrder.data('daterangepicker').setStartDate(date.toLocaleDateString('uk-UA'));
                    $dateOrder.data('daterangepicker').setEndDate(date.toLocaleDateString('uk-UA'));
                }
                for (let i = 0; i < fromArr.length; i++) {
                    if (fromArr[i].text >= fromMin && fromArr[i].text <= fromMax) {
                        timeFrom.push({
                            'Text': fromArr[i].text,
                            'Value': fromArr[i].value
                        });
                    }
                }
                let timeListFrom = timeFrom.map((item, index) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                $timeFromOrderDel.html(timeListFrom);
                $timeFromOrderDel.val(value);
                if (timeProp == null)
                    $timeFromOrder.val(null);
                $timeFromOrderDel.trigger('change');

                for (let i = 0; i < toArr.length; i++) {
                    if (toArr[i].text >= toMin && toArr[i].text <= toMax) {
                        timeTo.push({
                            'Text': toArr[i].text,
                            'Value': toArr[i].value
                        });
                    }
                }
                let timeListTo = timeTo.map((item, index) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                $timeToOrderDel.html(timeListTo);
                $timeToOrderDel.val(null);
                $timeToOrderDel.trigger('change');
                //$body.removeClass('is-loading');
            }
        });
    }

    function setEvents() {
        $(document).on('change', '[name="economTarif"]', function () {
            orderData['IsEconom'] = this.checked;
        });

        $(document).on('change', '[name="receiptNumber"], [name="availableReceiptsId"]', function () {
            receiptDelivery();
            // orderData['ReceiptOrder'] = '';
            // let receiptOrders = [];
            // let receiptInputArr = $('.js-receipt-val');
            // for (let i = 0; i < receiptInputArr.length; i++) {
            //     let valueInput = receiptInputArr[i].value;
            //
            //     if (valueInput == null || valueInput === ''  || valueInput.length === 0) {
            //         return
            //     } else {
            //         receiptOrders.push(valueInput);
            //     }
            //     orderData['ReceiptOrder'] = receiptOrders.join(';');
            // }
        });

        $(document).on('change', $wrap.find('input, select'), function () {
            let isValid;
            if ($receiptNumber.val() === null) {
                isValid = false;
            }
            const fields = $wrap.find( 'input,  select').filter('[data-required]');
            if (fields.length > 0) {
                isValid = fields.filter(function () {
                    return $.trim($(this).val()).length === 0
                }).length === 0;

                // if (isValid) {
                //     $('[ data-delivery-create]').removeClass('disabled');
                // } else {
                //     $('[ data-delivery-create]').addClass('disabled');
                // }
            }
        });

        $(document).on('change', '[name="paymentType"]', function () {
            orderData['PayTypeOrder'] = this.value;
        });

        $(document).on('change', '[name="isHalfDiscont"]', function () {
            orderData['IsHalfDiscont'] = this.value;
        });

        $(document).on('change', '[name="warehouseId"]', function () {
            orderData['WarehouseIdOrder'] = this.value;
        });

        $(document).on('change', '[name="contactPersonOrder"]', function () {
            orderData['ContactPersonOrder'] = this.value;
        });

        $(document).on('change', '[name="contactPhoneOrder"]', function () {
            orderData['ContactPhoneOrder'] = this.value;
        });

        $(document).on('select2:select', '[name="cityId"]', function () {
            orderData['CityId'] = this.value;
        });

        $(document).on('change', '[name="dateOrder"]', function () {
            orderData['DateOrder'] = this.value;
            getTimeIntervals();
        });

        $(document).on('change', '[name="organizationNameOrder"]', function () {
            orderData['OrganizationNameOrder'] = this.value;
        });

        $(document).on('change', '[name="emailOrder"]', function () {
            orderData['EmailOrder'] = this.value;
        });

        $(document).on('change', '[name="сommentOrder"]', function () {
            orderData['CommentOrder'] = this.value;
        });

        $(document).on('change', '[name="addressOrder"]', function () {
            orderData['AddressOrder'] = this.value;
        });

        $(document).on('select2:select', '[name="timeFromOrder"]', function () {
            orderData['TimeFromOrder'] = this.value;
            getTimeIntervals(null, $(this).find('option:selected').text());
        });

        $(document).on('select2:select', '[name="timeToOrder"]', function () {
            orderData['TimeToOrder'] = this.value;
        });

        $(document).on('change', '[name="noCallBack"]', function () {
            orderData['NoCallBack'] = this.checked;
        });

        $(document).on('change', '[name="hydrobortDelivery"]', function () {
            orderData['HydroOrderCheck'] = this.checked;
        });

        $(document).on('change', '[name="needAuto"]', function () {
            orderData['NeedAdditionalAutoCheck'] = this.checked;
        });

    }

    function validate ($inputs, checkPlaces = false) {
        const $allInputs = $('[data-required]');
        let $places;
        $places = $(element).find('[data-receipt-item].is-valid');
        const $emptyInputs = $inputs.filter(function () {
            return $.trim($(this).val()).length === 0
        });
        const inputsHasValue = $emptyInputs.length === 0;
        const hasValidPlaces = $places.length !== 0;

        $allInputs.parents('.form-item').removeClass('invalid');

        if (!inputsHasValue) {
            $emptyInputs.parents('.form-item').addClass('invalid')
        }
        if (!hasValidPlaces) {
            $(element).find('.is-active-place').addClass('invalid');
        } else {
            $(element).find('.is-active-place').removeClass('invalid');
        }

        return inputsHasValue && hasValidPlaces;
    }

    function setReceiptData($currentTemplate) {
        let data = {};

        data = {
            "receivingDateStr": $currentTemplate.find('[name="receivingDate"]').val(),
            "warehouseId": $currentTemplate.find('[name="warehouseId"] option:selected').text(),
            "statusReceiptStr": $currentTemplate.find('[name="statusReceipt"]').val(),
            "receiptNumber": $currentTemplate.find('[name="receiptNumber"]').val() || $currentTemplate.find('[name="receiptsId"]').val() || $currentTemplate.find('[name="availableReceiptsId"]').val(),
        }
        return data;
    }

    function updateReceiptInfo($currentTemplate, data) {
        $currentTemplate.data('receipt-number', data['receiptNumber']);
        const $currentTemplateCollapsed = $currentTemplate.find('[data-receipt-collapsed]');
        $currentTemplate.removeClass('is-active-place is-editable');
        $currentTemplate.addClass('saved');
        $currentTemplate.find('[data-receipt-form]').addClass('_hide');
        $currentTemplateCollapsed.find('[data-receipt-number]').text(data['receiptNumber']);
        $currentTemplateCollapsed.find('[data-receipt-route]').text(data['warehouseId']);
        $currentTemplateCollapsed.find('[data-receipt-status]').text(data['statusReceiptStr']);
        $currentTemplateCollapsed.find('[data-receipt-date]').text(data['receivingDateStr']);
        $currentTemplateCollapsed.removeClass('_hide');
    }

    function getRequestDelivery(value) {
        const notyText = translates['receiptsNotFoundMessage'];
        if (addedReceipts.includes(value)) {
            notifier.error(translates['youHaveAlreadyAddedThisReceipt']).then((noty) => {
                noty.show();
            });
            return false;
        }

        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetReceiptInfo',
            type: 'post',
            data: {
                'receiptNumber': value,
            },
            success: (response) => {
                const data = response['receiptInfoModel'];
                if (data != null) {
                    switch(data.statusReceipt) {
                        case 0:
                        case 1:
                        case 8:
                        case 9:
                            notifier.error(translates.unableToAddReceipt).then((noty) => {
                                noty.show();
                            });
                            break;
                        default:
                            setWarehouseList(warehouseList);
                            $('.is-active-place').find('[name="warehouseId"]').val(data['warehouseId']).trigger('change');
                            $('.is-active-place').find('[name="statusReceipt"]').val(data['statusReceiptStr']);
                            $('.is-active-place').find('[name="receivingDate"]').val(data['receivingDateStr']);
                            $('[data-add-receipt]').removeClass('disabled').addClass('is-active');
                            $('[data-receipt-check]').removeClass('_hide');
                            $('.is-active-place').addClass('is-valid');

                            deliverySum['tarifCost']['weight'] = data['weight'];
                            deliverySum['tarifCost']['volume'] = data['volume'];
                            deliverySum['tarifCost']['places'] = data['place'];
                            let params = new URLSearchParams(window.location.href.split('?')[1]);

                            if (params.get('number')) {
                                $('.is-active-place').find('[name="warehouseId"]').val(data['warehouseId']).trigger('select2:select').trigger('change');
                                $organizationNameOrder.val(data['contactPerson'] === '' ? data['organizationName'] : data['contactPerson']).trigger('change');
                                $emailOrder.val(data['email']).trigger('change');
                                $contactPersonOrder.val(data['phone']).trigger('change');
                                $contactPhoneOrder.val(data['phone']).trigger('change');
                                $paymentType.val(data['paymentType']).trigger('change');
                            }

                            // $cityIdFirst = data['cityDispatching'];
                            // $cityId.val($cityIdFirst).trigger('change');
                            // $cityId.trigger('select2:select');
                            addedReceipts.push(value);
                    }
                } else {
                    notifier.error(notyText).then((noty) => {
                        noty.show();
                    });
                    $('.is-active-place').find('[name="warehouseId"]').val(null);
                    $('.is-active-place').find('[name="statusReceipt"]').val(null);
                    $('.is-active-place').find('[name="receivingDate"]').val(null);
                    // $cityId.val(null);
                    $('[data-add-receipt]').addClass('disabled').removeClass('is-active');
                    $('[data-receipt-check]').addClass('_hide');
                    $('.is-active-place').removeClass('is-valid');
                }
            }
        })
    }

    function getDeliveryInfo() {
        // $wrap.addClass('is-loading');
        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetDeliveryInit',
            type: 'get',
            success: (response) => {
                const queryString = window.location.search;
                const hasParam = queryString.includes("?number");
                let URLParams = new URLSearchParams(window.location.href.split('?')[1]);
                if(!hasParam) {
                    $organizationNameOrder.val(response['OrganizationNameOrder']).trigger('change');
                    $emailOrder.val(response['EmailOrder']).trigger('change');
                    $contactPersonOrder.val(response['ContactPersonOrder']).trigger('change');
                    $contactPhoneOrder.val(response['ContactPhoneOrder']).trigger('change');
                }
                // let data = response['CityList'].map((item) => {
                //     return (`<option value="${item['Value']}">${item['Text']}</option>`)
                // });
                // $cityId.html(data);
                // $cityId.val(null);

                let time = response['TimeList'].map((item) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                $timeFromOrderDel.html(time);
                $timeFromOrderDel.val(null);
                $timeToOrderDel.html(time);
                $timeToOrderDel.val(null);
                fromArr = $wrap.find('[name="timeFromOrder"] option');
                toArr = $wrap.find('[name="timeToOrder"] option');
                warehouseList = response['WarehouseList'].map((item) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                setWarehouseList(warehouseList);
                let date = new Date();

                let formattedDate = `${date.toLocaleDateString('fr-CA')}T${date.toLocaleTimeString()}`;
                getTimeIntervals(formattedDate);
                // $wrap.removeClass('is-loading');
            }
        })
    }

    function setWarehouseList(warehouses) {
        $('.is-active-place').find('[name="warehouseId"]').html(warehouses);
        $('.is-active-place').find('[name="warehouseId"]').val(null);
    }

    function deliveryCost() {
        let test = $wrapper.find('.is-valid');
        let data = [{
            weight: deliverySum['tarifCost']['weight'],
            volume: deliverySum['tarifCost']['volume'],
            places: deliverySum['tarifCost']['places'],
            palletId: null,
            cityId: $cityId.find('option:selected').val(),
            cost: 0,
            tarifName: null,
            isNegabarit: false,
            needAuto: $needAuto.prop('checked'),
            isPick: deliverySum['tarifCost']['isPick'],
            hydroB: $hydrobortDelivery.prop('checked'),
            numReceipts: test.length
        }];

        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetTarifCost',
            type: 'post',
            data: { model: data },
            success: (response) => {
                $totalSum.text('');
                $totalSum.text(response['totalSum']);
            }
        })
    }

    function createDelivery() {
        const valid = validate($(element).find('[data-required]'), true);
        orderData['ReceiptOrder'] = '';
        orderData['ReceiptOrder'] = addedReceipts.join(';');

        if (valid) {
            $body.addClass('is-loading');
            $.ajax({
                url: '/' + window.currentLang + '/SharedForms/DelivHyper',
                type: 'post',
                data: orderData,
                dataType: "json",
                success: (response) => {
                    $body.removeClass('is-loading');
                    if (response['status']) {
                        $('[data-receipt-number]').text(response['receptNumber']);
                        magnificPopup.open({
                            items: {
                                src: '#applicationSent'
                            },
                            type: 'inline'
                        });
                        orderData = '';
                    } else {
                        notifier.error(response['message']).then((noty) => {
                            noty.show();
                        });
                    }
                }
            })
        }
    }

    function receiptDelivery() {
        $.ajax({
            url: '/' + window.currentLang + '/UserReceipts/GetReceiptsWithSameReceiveCity',
            type: 'get',
            data: {
                'receiptNumber': isAuthorized === 'true' ? $('.is-active-place').find('[name="availableReceiptsId"]').val() : $('.is-active-place').find('[name="receiptNumber"]').val()
            },
            success: (response) => {
                receiptList = response;
            }
        })
    }

    availableReceipts();

    function receiptsForDelivery() {
        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetReceiptsForDelivery',
            type: 'get',
            success: (response) => {
                let data = response.map((item, index) => {
                    return (`<option value="${item['name']}">${item['name']}</option>`)
                });
                $('.is-active-place [name="availableReceiptsId"]').html(data);
                if (URLParams.get('number')) {
                    if(isAuthorized === 'true') {
                        $('.is-active-place [name="availableReceiptsId"]').val(URLParams.get('number')).trigger('select2:select').trigger('change');
                    } else {
                        $('.is-active-place').find('[name="receiptNumber"]').val(URLParams.get('number'));
                    }
                } else {
                    $('.is-active-place [name="availableReceiptsId"]').val(null);
                }
            }
        })
    }

    function toggleSearchField() {
        const $currentPlace = $('.is-active-place');
        if (isAuthorized === 'true') {
            $currentPlace.find('[data-search-field]').addClass('_hide')
            $currentPlace.find('[data-search-select]').removeClass('_hide')
            $currentPlace.find('[data-select-available-receipts]').addClass('_hide');

        } else if (isAuthorized === 'false') {
            $currentPlace.find('[data-search-field]').removeClass('_hide');
            $currentPlace.find('[data-search-select]').addClass('_hide');
            $currentPlace.find('[data-select-available-receipts]').addClass('_hide');
        }
    }

    function availableReceipts() {
        const $currentPlace = $('.is-active-place');

        if (isAuthorized === 'true') {
            $currentPlace.find('[data-search-field]').addClass('_hide');
            $currentPlace.find('[data-select-available-receipts]').removeClass('_hide');
        } else if (isAuthorized === 'false') {
            $currentPlace.find('[data-search-field]').removeClass('_hide');
            $currentPlace.find('[data-select-available-receipts]').addClass('_hide');
        }
    }

    const queryString = window.location.search;
    const hasParam = queryString.includes("?number");
    let URLParams = new URLSearchParams(window.location.href.split('?')[1]);

    if(hasParam) {
        $('[data-tabs-button="delivery"]').trigger('click');
        getDeliveryInfo();
        receiptsForDelivery();
    }

    $('[data-tabs-button="delivery"]').on('click', function () {
        setEvents();
        getDeliveryInfo();
        receiptsForDelivery();
    });
}

export default function (element) {
    init(element);
}